import React from "react";
import { TransactionTable } from "components";
import { Loader } from "components/common";
import { GetTransactionsHook } from "hooks";

const TransactionsListing = () => {
  const { data, error, loading } = GetTransactionsHook();

  return (
    <div>
      {loading ? <Loader content="Loading Transactions" /> : ""}

      {data ? <TransactionTable data={data.get_transactions} /> : ""}
    </div>
  );
};

export default TransactionsListing;
